import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/entitlement/sites/entitlementDetails/initialState.entitlementDetails.data';
import {
  fetchSiteEntitlementDetailsData as fetchSiteEntitlementDetailsDataAPI,
  fetchSiteEntitlementCount as fetchSiteEntitlementCountAPI,
  fetchEntitlementsStatus as fetchEntitlementsStatusAPI,
  fetchServiceProductData as fetchServiceProductDataAPI,
  fetchServiceLevelData as fetchServiceLevelDataAPI,
  entitlementSummaryData as entitlementSummaryDataAPI,
  updateSiteEntitlementContractHistoryData as updateSiteEntitlementContractHistoryAPI,
} from '../../../../apis/siteAPI';
import { handlePending, handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';
import { ACTIONS_SITE_ENTITLEMENT_DETAILS } from '../../../../constants/actionCreator';

//API to get data by Entitlement Id for Entitlements
export const fetchSitesEntitlementDetailsData = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.FETCH_SITE_ENTITLEMENT_DETAILS,
  fetchSiteEntitlementDetailsDataAPI
);

//API to fetch Site Entitlements Count
export const fetchSiteEntitlementCount = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.FETCH_SITE_ENTITLEMENT_DETAILS_COUNT,
  fetchSiteEntitlementCountAPI
);

//API to get data for Entitlement Status
export const fetchEntitlementsStatus = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.FETCH_SITE_ENTITLEMENT_DETAILS_ENTITLEMENTS_STATUS,
  fetchEntitlementsStatusAPI
);
// API to get data for service product
export const fetchServiceProductData = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.FETCH_SERVICE_PRODUCT_DATA,
  fetchServiceProductDataAPI
);

//API to get the service level Data
export const fetchServiceLevelData = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.FETCH_SEVICE_LEVEL_DATA,
  fetchServiceLevelDataAPI
);

export const entitlemenSummarySave = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.Entitlemen_Summary_Data,
  entitlementSummaryDataAPI
);

export const SiteEntitlementContractHistoryUpdate = createAsyncThunkWrapper(
  ACTIONS_SITE_ENTITLEMENT_DETAILS.UPDATE_SITE_ENTITLEMENT_CONTRACT_HISTORY,
  updateSiteEntitlementContractHistoryAPI
);

const entitlementDetailsSlice = createSlice({
  name: 'entitlementDetails',
  initialState,
  reducers: {
    handleEntitlementEidLockdown: (state, action) => {
      state.searchOptions.eid_Lockdown = action?.payload?.value;
      state.searchOptions.eid_LockdownName = action?.payload?.name;
    },
    handleEntitlementVoyixOwned: (state, action) => {
      state.searchOptions.voyix_Owned = action?.payload?.value;
      state.searchOptions.voyix_OwnedName = action?.payload?.name;
    },
    handleEntitlementStatus: (state, action) => {
      state.searchOptions.statusId = action?.payload?.value;
      state.searchOptions.statusName = action?.payload?.name;
    },
    handleEffectiveDate: (state, action) => {
      state.searchOptions.effectiveDate = action?.payload || null;
    },
    handleProductCodeContains: (state, action) => {
      state.searchOptions.serviceProductCodeContains = action?.payload || '';
    },
    handleProductNameContains: (state, action) => {
      state.searchOptions.serviceProductNameContains = action?.payload || '';
    },
    resetSearchData: (state) => {
      state.searchOptions.effectiveDate =
        initialState.searchOptions.effectiveDate;
      state.searchOptions.statusId = initialState.searchOptions.statusId;
      state.searchOptions.statusName = initialState.searchOptions.statusName;
      state.searchOptions.serviceProductCodeContains =
        initialState.searchOptions.serviceProductCodeContains;
      state.searchOptions.serviceProductNameContains =
        initialState.searchOptions.serviceProductNameContains;
      state.siteEntitlementDetailsData =
        initialState.siteEntitlementDetailsData;
      state.searchOptions.eid_Lockdown = initialState.searchOptions.eid_Lockdown;
      state.searchOptions.eid_LockdownName = initialState.searchOptions.eid_LockdownName;
      state.searchOptions.voyix_Owned = initialState.searchOptions.voyix_Owned;
      state.searchOptions.voyix_OwnedName = initialState.searchOptions.voyix_OwnedName;
    },
    handleSearchFilters: (state, action) => {
      state.activeSearch.effectiveDate = action?.payload?.effectiveDate;
      state.activeSearch.status = action?.payload?.status;
      state.activeSearch.eid_Lockdown = action?.payload?.eid_Lockdown;
      state.activeSearch.voyix_Owned = action?.payload?.voyix_Owned;
      state.activeSearch.serviceProductCode =
        action?.payload?.serviceProductCode;
      state.activeSearch.serviceProductName =
        action?.payload?.serviceProductName;
    },
    handleTempAddMoadalValue: (state, action) => {
      state.tempAddModalValue = action.payload;
    },
    setCurrencyId: (state, action) => {
      state.currencyId = action.payload?.currencyId
        ? action.payload?.currencyId
        : initialState.currencyId;
    },
    setEntitlementId: (state, action) => {
      state.entitlementId = action.payload
        ? action.payload
        : initialState.entitlementId;
    },
    setApiResponseData: (state, action) => {
      state.apiRes = action.payload ? action.payload : initialState.apiRes;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSitesEntitlementDetailsData.pending, (state, action) => {
        handlePending(state, action);
        state.isSiteEntitlementsDetailsResultsFound = null;
        state.siteEntitlemenDetailsCount = 0;
        state.siteEntitlementDetailsData = [];
        state.siteEntitlementDetailsLoading = true;
      })
      .addCase(fetchSitesEntitlementDetailsData.fulfilled, (state, action) => {
        state.loading = false;
        state.siteEntitlementDetailsLoading = false;
        state.siteEntitlementDetailsData = action?.payload? action?.payload : [];
        state.siteEntitlemenDetailsCount = action?.payload
          ? action?.payload[0]?.totalRecords
          : 0;
        state.isSiteEntitlementsDetailsResultsFound =
          action?.payload?.length === 0;
      })
      .addCase(fetchSitesEntitlementDetailsData.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.siteEntitlementDetailsLoading = false;
        state.isSiteEntitlementsDetailsResultsFound = true;
        state.siteEntitlemenDetailsCount = 0;
      })

      .addCase(fetchSiteEntitlementCount.pending, (state, action) => {
        handlePending(state, action);
        state.loading = true;
        state.siteEntitlementCount = 0;
      })
      .addCase(fetchSiteEntitlementCount.fulfilled, (state, action) => {
        state.loading = false;
        state.siteEntitlementCount = action?.payload
          ? action?.payload?.[0]?.totalRecords
          : 0;
      })
      .addCase(fetchSiteEntitlementCount.rejected, (state, action) => {
        handleRejection(state, action);
        state.loading = false;
        state.siteEntitlementCount = 0;
      })

      .addCase(fetchEntitlementsStatus.pending, (state) => {
        state.loading = true;
        state.searchOptions.status = [];
      })
      .addCase(fetchEntitlementsStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.searchOptions.status = action?.payload ? action.payload : [];
      })
      .addCase(fetchEntitlementsStatus.rejected, (state) => {
        state.loading = false;
        state.searchOptions.status = [];
      })
      .addCase(fetchServiceProductData.pending, (state) => {
        state.isServiceProductDataFound = false;
        state.serviceProductData = [];
        state.totalRecordsProdData = 0;
        state.isServiceProductLoading = true;
      })
      .addCase(fetchServiceProductData.fulfilled, (state, action) => {
        state.isServiceProductDataFound = true;
        state.serviceProductData = action?.payload ? action?.payload : [];
        state.totalRecordsProdData = action?.payload
          ? action?.payload[0].totalRecords
          : 0;
        state.isServiceProductLoading = false;
      })
      .addCase(fetchServiceProductData.rejected, (state) => {
        state.isServiceProductDataFound = false;
        state.serviceProductData = [];
        state.totalRecordsProdData = 0;
        state.isServiceProductLoading = false;
      })
      .addCase(fetchServiceLevelData.pending, (state) => {
        state.loading = true;
        state.serviceLevelData = [];
      })
      .addCase(fetchServiceLevelData.fulfilled, (state, action) => {
        state.loading = false;
        state.serviceLevelData = action?.payload ? action?.payload : [];
      })
      .addCase(fetchServiceLevelData.rejected, (state) => {
        state.loading = false;
        state.serviceLevelData = [];
      })
      .addCase(entitlemenSummarySave.pending, (state) => {
        state.tempAddLoading = true;
        state.entitlementId = '';
        state.apiRes = 'pending';
      })
      .addCase(entitlemenSummarySave.fulfilled, (state, action) => {
        state.tempAddLoading = false;
        state.entitlementId = action?.payload ? action?.payload : [];
        state.tempAddModalValue = false;
        state.apiRes = 'success';
      })
      .addCase(entitlemenSummarySave.rejected, (state) => {
        state.tempAddLoading = false;
        state.entitlementId = '';
        state.apiRes = 'failed';
      })
      .addCase(SiteEntitlementContractHistoryUpdate.pending, (state) => {
        state.updateButtonLoading = true;
        state.siteEntilementContracteUpdateData = null;        
      })
      .addCase(SiteEntitlementContractHistoryUpdate.fulfilled, (state, action) => {
        state.siteEntilementContracteUpdateData = action?.payload ? action?.payload : [];
        state.updateButtonLoading = false;        
      })
      .addCase(SiteEntitlementContractHistoryUpdate.rejected, (state) => {
        state.updateButtonLoading = false;
        state.siteEntilementContracteUpdateData = false;        
      });
  },
});

export const {
  handleEntitlementStatus,
  handleEffectiveDate,
  handleProductCodeContains,
  handleProductNameContains,
  resetSearchData,
  handleSearchFilters,
  handleTempAddMoadalValue,
  setCurrencyId,
  setEntitlementId,
  setApiResponseData,
  handleEntitlementEidLockdown,
  handleEntitlementVoyixOwned,
} = entitlementDetailsSlice.actions;

export default entitlementDetailsSlice.reducer;
